import { render, staticRenderFns } from "./SingUp.vue?vue&type=template&id=f3cb4282&scoped=true&"
import script from "./SingUp.vue?vue&type=script&lang=js&"
export * from "./SingUp.vue?vue&type=script&lang=js&"
import style0 from "./SingUp.vue?vue&type=style&index=0&id=f3cb4282&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cb4282",
  null
  
)

component.options.__file = "SingUp.vue"
export default component.exports